export default "__VITE_ASSET__Du2pe3oX__"